module.exports = new __parcel__URL__("settings-02.d69d69bd.webp").toString();